'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ReactCSSTransitionGroup = require('react/lib/ReactCSSTransitionGroup');

var _ReactCSSTransitionGroup2 = _interopRequireDefault(_ReactCSSTransitionGroup);

var _Portal = require('./Portal');

var _Portal2 = _interopRequireDefault(_Portal);

var _reactFixedPage = require('react-fixed-page');

var _reactFixedPage2 = _interopRequireDefault(_reactFixedPage);

var _reactDemo = require('react-demo');

var _reactDemo2 = _interopRequireDefault(_reactDemo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SidebarTransition = function SidebarTransition(props) {
  return _react2.default.createElement(_ReactCSSTransitionGroup2.default, _extends({
    transitionName: 'sidebar',
    transitionEnterTimeout: 400,
    transitionLeaveTimeout: 400
  }, props));
};

var Sidebar = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar() {
    _classCallCheck(this, Sidebar);

    return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
  }

  _createClass(Sidebar, [{
    key: 'renderSidebar',
    value: function renderSidebar() {
      var _props = this.props,
          open = _props.open,
          children = _props.children,
          onClose = _props.onClose,
          backdrop = _props.backdrop,
          rest = _objectWithoutProperties(_props, ['open', 'children', 'onClose', 'backdrop']);

      if (!open) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'sidebar' },
        backdrop ? _react2.default.createElement('div', { className: 'sidebar-backdrop', onClick: onClose }) : null,
        _react2.default.createElement(
          'div',
          _extends({ className: 'sidebar-content' }, rest),
          children
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _Portal2.default,
          null,
          _react2.default.createElement(
            SidebarTransition,
            null,
            this.renderSidebar()
          )
        ),
        _react2.default.createElement(_reactFixedPage2.default, { fixed: this.props.open })
      );
    }
  }]);

  return Sidebar;
}(_react.Component);

Sidebar.propTypes = {
  open: _react.PropTypes.bool.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  backdrop: _react.PropTypes.bool
};
Sidebar.defaultProps = {
  backdrop: true
};

Sidebar.demo = function () {
  return _react2.default.createElement(
    _reactDemo2.default,
    { props: {
        open: _reactDemo.props.bool(false),
        backdrop: _reactDemo.props.bool(true)
      } },
    function (props, update) {
      return _react2.default.createElement(
        Sidebar,
        _extends({}, props, { onClose: function onClose() {
            return update({ open: false });
          } }),
        _react2.default.createElement(
          'p',
          null,
          'Hello World!'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Life in the sidebar is grand!'
        )
      );
    }
  );
};

exports.default = Sidebar;


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-ui/lib/components/Sidebar.js
// module id = 406
// module chunks = 0